import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from '../../../../environments/environment';
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class PublicService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public getListOfRegions(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'public-ascon/publicAscon/getListOfRegions', { params });
  }

  public getListOfUnitCodes(): Observable<any> {
    const params = new HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getListOfUnitCodes', { params });
  }

  public getListOfAllUnitCodes(): Observable<any> {
    const params = new HttpParams();
    return this.httpClient.get(this.SERVER_URL + 'company-profile/companyProfile/getListOfAllUnitCodes', { params });
  }

  public getExchange(year, month, day, currency) {
    let params = new HttpParams()
      .set('year', year)
      .set('month', month)
      .set('day', day)
      .set('currency', currency);

    return this.httpClient.get(this.SERVER_URL + 'public-ascon/publicAscon/getExchange', { params });
  }

  public getTaric(): Observable<any> {
    const params = new HttpParams();

    return this.httpClient.get(this.SERVER_URL + 'public-ascon/publicAscon/getTaric', { params });
  }

  public getAppVersion() {
    return this.httpClient.get(this.SERVER_URL + 'public-ascon/publicAscon/getAppVersion')
  }

  public getVats() {
    return this.httpClient.get(this.SERVER_URL + 'public-ascon/publicAscon/getVats');
  }

  public queryExchange(date: moment.Moment, currency: string) {
    const year = date.format('YYYY');
    const month = date.format('M');
    const day = date.format('D');
    return new Promise((resolve, reject) => {
      this.getExchange(year, month, day, currency.toLowerCase()).subscribe(
        (res: { data: string }) => {
          if (!isNaN(parseFloat(res.data))) {
            resolve(parseFloat(res.data));
          } else {
            return reject(`Nu există date pentru cursul valutar al ${currency} în ${day}-${month}-${year}!`);
          }
        }, () => { return reject(`Nu am reușit să citim cursul valutar al ${currency}!`) }
      );
    })
  }
  
}
